__turbopack_context__.v({
  "className": "XT7ZBW_className",
  "variable": "XT7ZBW_variable",
});
